<template>
  <span>
    <b-row style="margin-top: 40px; width: 98%" class="mx-auto">
      <b-col col lg="12">
        <b-card>
          <div class="mail-tabs">
            <!-- Tab links -->
            <div class="tab">
              <button
                :class="[
                  this.tab_id === 'inbox' ? activeClass : '',
                  'tablinks',
                ]"
                @click="openTab('inbox')"
              >
                Inbox
              </button>
              <button
                :class="[
                  this.tab_id === 'outbox' ? activeClass : '',
                  'tablinks',
                ]"
                @click="openTab('outbox')"
              >
                Outbox
              </button>
            </div>

            <!-- Tab content -->
            <div id="inbox" class="tabcontent1">
              <b-row>
                <b-col class="results" col lg="12">
                  <table class="table">
                    <thead>
                      <th>Tracking No</th>
                      <th>Item</th>
                      <th>Type</th>
                      <th>Sender</th>
                      <th>Recipient</th>
                      <th>Origin</th>
                      <th>Destination</th>
                      <th>Booking Date</th>
                      <th>Status</th>
                    </thead>
                    <tbody>
                      <tr v-for="mail in getInbox" :key="mail.mail_id">
                        <td>
                          <span class="key-label">{{ mail.trck_number }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.mail_item }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.mail_type }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.sender_contact }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.receiver_contact }}</span>
                        </td>
                        <td>
                          <span class="location">{{ mail.source }}</span>
                        </td>
                        <td>
                          <span class="location">{{ mail.destination }}</span>
                        </td>
                        <td>
                          <span class="date">{{
                            getFriendlyDate(mail.booking_date.split(" ")[0])
                          }}</span>
                          <span class="time">{{
                            mail.booking_date.split(" ")[1]
                          }}</span>
                        </td>
                        <td>
                          <span class="status">{{ mail.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </div>

            <div id="outbox" class="tabcontent1">
              <b-row>
                <b-col class="results" col lg="12">
                  <table class="table">
                    <thead>
                      <th>Tracking No</th>
                      <th>Item</th>
                      <th>Type</th>
                      <th>Sender</th>
                      <th>Recipient</th>
                      <th>Origin</th>
                      <th>Destination</th>
                      <th>Booking Date</th>
                      <th>Status</th>
                    </thead>
                    <tbody>
                      <tr v-for="mail in getOutbox" :key="mail.mail_id">
                        <td>
                          <span class="key-label">{{ mail.trck_number }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.mail_item }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.mail_type }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.sender_contact }}</span>
                        </td>
                        <td>
                          <span class="label">{{ mail.receiver_contact }}</span>
                        </td>
                        <td>
                          <span class="location">{{ mail.source }}</span>
                        </td>
                        <td>
                          <span class="location">{{ mail.destination }}</span>
                        </td>
                        <td>
                          <span class="date">{{
                            getFriendlyDate(mail.booking_date.split(" ")[0])
                          }}</span>
                          <span class="time">{{
                            mail.booking_date.split(" ")[1]
                          }}</span>
                        </td>
                        <td>
                          <span class="status">{{ mail.status }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </span>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Mail",
  data() {
    return {
      address: "",
      tab_id: "inbox",
      activeClass: "active",
      centerLat: 0.3189395,
      centerLon: 32.5713168,
      po_lat: 0.3189395,
      po_lon: 32.5713168,
      place: null,
    };
  },
  component: {},
  computed: {
    ...mapGetters([
      "getInbox",
      "getOutbox",
      "getRequestResponse",
      "getClientId",
      "getClientPhone",
    ]),
    google: gmapApi,
  },
  mounted() {
    this.openTab(this.tab_id);
    let data = {
      phone: this.getClientPhone,
    };
    this.fetchInbox(data);
    this.fetchOutbox(data);
  },
  methods: {
    ...mapActions(["fetchInbox", "fetchOutbox", "getCalculation"]),

    openTab: function (id) {
      this.tab_id = id;
      // Declare all variables
      var i, tabcontent, tablinks;

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName("tabcontent1");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }

      document.getElementById(id).style.display = "block";
    },
    getAddressData: function (addressData, placeResultData, id) {
      // this.address = addressData;
      console.log(JSON.stringify(addressData));
      console.log(JSON.stringify(placeResultData));
      console.log(id);
    },
    getFriendlyDate: function (date) {
      var sections = date.split("-");
      return sections[2] + "/" + sections[1] + "/" + sections[0];
    },
  },
};
</script>

<style scoped>
@import "../../commons/tables.css";

.mail-tabs {
  width: 90%;
  margin-top: 10px;
  margin-left: 20px;
}

/* Style the tab */
.tab {
  overflow: hidden;
  background: #f1f1f1;
}

/* Style the buttons that are used to open the tab content */
.tab button {
  background-color: inherit;
  float: left;
  border: 2px solid #dedede;
  margin-right: 2px;
  outline: none;
  cursor: pointer;
  padding: 8px 20px;
  transition: 0.3s;
  font-size: 14px;
  font-weight: bold;
  color: #5e5e5e;
  width: 150px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #f1f1f1;
}

/* Create an active/current tablink class */
.tab button.active {
  color: #fff;
  background: #db0000;
  border: 2px solid #9f0012;
}

/* Style the tab content */
.tabcontent1 {
  display: none;
  border: none;
}

img {
  width: 35px;
  height: 35px;
}

img:hover {
  width: 36px;
}

img:focus {
  background: #dedede;
}

.results {
  margin-top: 10px;
}

.key-label {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
}

.label {
  color: #222222;
  font-size: 14px;
}

.location {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
  font-style: italic;
}

.date {
  color: #443bff;
  font-weight: bold;
  font-size: 14px;
}

.time {
  color: #fff;
  background: #5e5e5e;
  font-style: italic;
  border-radius: 6px;
  padding: 2px 4px;
  margin-left: 5px;
  font-size: 14px;
}

.status {
  font-size: 14px;
  background: #0a7027;
  color: white;
  padding: 4px 8px;
  border-radius: 3px;
  margin-left: 1px;
  font-weight: bold;
  text-align: center;
}
</style>
